import Vue from "vue";
import VueI18n from "vue-i18n";
import ko from "./locales/ko.json";
import en from "./locales/en.json";
import store from "./store/index.js";

Vue.use(VueI18n);

export default new VueI18n({
  // locale: localStorage.getItem("default") ? JSON.parse(localStorage.getItem("default")).locale : 'ko',
  // fallbackLocale: localStorage.getItem("default") ? JSON.parse(localStorage.getItem("default")).locale : 'ko',
  locale: store?.state?.user_info?.language || 'ko',
  fallbackLocale: store?.auth?.user_info?.language || 'ko',
  messages: { ko, en },
});
